import { waitFor } from '@codeleap/utils'
import { onUpdate } from '@codeleap/hooks'
import { QueryKeys } from './queryKeys'
import { firebase } from '@/services/firebase'
import { useProfile } from './useProfile'
import { appStatusStore } from '@/stores'
import { useSessionMode } from './useSessionMode'
import { ConnectID, Profiles } from '@/services'

import '../queryClient'
import { loadTheme } from './utils'

async function resolveAuth() {
  await waitFor(1000)

  const currentProfile = QueryKeys.me.getData()

  if (!currentProfile) {
    appStatusStore.set('idle')
    appStatusStore.setHasResolvedInitialAuth(true)
    return
  }
  
  await Profiles.Services.loadFeatures()
  const shouldContinue = await loadTheme()
  if (!shouldContinue) return
  appStatusStore.set('idle')
  appStatusStore.setHasResolvedInitialAuth(true)
}

export function useSession(root = false) {
  const sessionMode = useSessionMode(root)
  const connectUser = ConnectID.useConnectIDAuthState()
  const connectAuthReady = ConnectID.useConnectIDAuthReady()

  const profile = useProfile({
    enabled: root && sessionMode.loaded && connectAuthReady,
  })

  const authFinished = appStatusStore.state.use(state => state.authFinished)
  const initialAuthResolved = appStatusStore.state.use(state => state.hasResolvedInitialAuth)

  const hasProfile = typeof profile?.data?.id !== 'undefined'
  const profileResolved = hasProfile ? (profile?.data?.id === connectUser?.profile?.sub) || profile?.isError : true
  const loginResolved = sessionMode.loaded && connectAuthReady && profileResolved && profile?.isFetched

  onUpdate(() => {
    if (root && loginResolved && !initialAuthResolved) {
      resolveAuth()
    }
  }, [loginResolved])

  return {
    profile: profile.data,
    isLoggedIn: profile.isLoggedIn,
    loginResolved,
    authFinished,
    profileQuery: profile,
  }
}

export const useIsSocialLogin = () => {
  // TODO LinkedIn Auth
  // const loggedInWithLinkedin = useAppSelector(store => !!store.Session?.firebaseUserClaims?.linkedin_id)

  const firebaseUser = firebase.auth.currentUser

  const isSocialLogin = !!firebaseUser?.providerData?.some((provider) => provider?.providerId !== 'password')

  return {
    isSocialLogin,
    firebaseUser,
  }
}
